import {AuthLayout} from 'components/layouts';
import {useSelector} from 'react-redux';
import {Navigate} from 'react-router-dom';
import {appRoutes} from 'routes/config';
import {sessionSelector} from 'store/auth/sessionSlice';

const AuthRouteRenderer: React.FC = () => {
    const {jwtToken, tenantSlug, workspaceSlug, boardSlug} = useSelector(sessionSelector);
    const isAuthenticated = !!jwtToken;

    if (isAuthenticated) {
        return <Navigate to={appRoutes.workspace.boardListing(tenantSlug, workspaceSlug, boardSlug)} />;
    }

    return <AuthLayout />; // Don't pass children, as AuthLayout already has <Outlet />
};

export default AuthRouteRenderer;
